<template>
  <div class="rastreo">

    <div v-show="this.loaded">

        <template v-if="this.httpstatus == '401' || this.httpstatus == '400' || this.order.length < 1">
          <pedido-not-found></pedido-not-found>
        </template>

        <template v-else>

            
            <pedido-map
              :latitud="order.y"
              :longitud="order.x"
            ></pedido-map>
             <p class="text-center"><!--{{this.$vuetify.breakpoint.name}}--></p> 
           
            
            
           
            <v-col sm="12" md="10" offset-md="1" lg="8" offset-lg="2" class="pt-6">         
                <v-row>

                  <v-col lg="4"  offset-lg="1" md="5" sm="5" cols="12">
                      <pedido-seguimiento
                        :order="order"
                      ></pedido-seguimiento>
                  </v-col>

                  <v-col  lg="7" md="7" sm="7" cols="12">

                      <!-- Información personal -->
                      <v-card  outlined tile class="mb-6">

                        <v-card-title class="px-3 py-2" style="background-color:#F5F5F5; color:#686D70; border-bottom: 1px solid #E0E0E0;" >
                          <v-icon >mdi-account-outline</v-icon>
                          <span class="body-1 text-center font-weight-bold ml-2">Información General</span>
                        </v-card-title>

                        <v-card-text class="px-6 py-6">
                          <v-row>
                            <v-col lg="1" md="1" sm="1" class="d-none d-sm-flex"></v-col>
                            <v-col lg="4" md="4" sm="3" cols="4"><p class="text-left mb-0">Nombre</p></v-col>
                            <v-col lg="7" md="7" sm="8" cols="8"><p class="text-left mb-0" >{{this.order.p.n}}</p></v-col>
                          </v-row>

                          <v-row>
                            <v-col lg="1" md="1" sm="1" class="d-none d-sm-flex"></v-col>
                            <v-col lg="4" md="4" sm="3" cols="4"><p class="text-left mb-0">Email</p></v-col>
                            <v-col lg="7" md="7" sm="8" cols="8"><p class="text-left mb-0" >{{this.order.p.e.length == 0 ? 'Sin información': this.order.p.e }}</p></v-col>
                          </v-row>

                          <v-row>
                            <v-col lg="1" md="1" sm="1" class="d-none d-sm-flex"></v-col>
                            <v-col lg="4" md="4" sm="3" cols="4"><p class="text-left mb-0">Teléfono</p></v-col>
                            <v-col lg="7" md="7" sm="8" cols="8"><p class="text-left mb-0" >{{this.order.p.p.length == 0 ? 'Sin información': formatPhone(this.order.p.p) }}</p></v-col>
                          </v-row>

                          <v-row>
                            <v-col lg="1" md="1" sm="1" class="d-none d-sm-flex"></v-col>
                            <v-col lg="4" md="4" sm="3" cols="4"><p class="text-left mb-0">Dirección</p></v-col>
                            <v-col lg="7" md="7" sm="8" cols="8"><p class="text-left mb-0" >{{this.order.p.a}}</p></v-col>
                          </v-row>

                          <v-row v-if="this.order.s >= 2">
                            <v-col lg="1" md="1" sm="1" class="d-none d-sm-flex"></v-col>
                            <v-col lg="4" md="4" sm="3" cols="4"><p class="text-left mb-0">Fecha Despacho</p></v-col>
                            <v-col lg="7" md="7" sm="8" cols="8"><p class="text-left mb-0" > {{ formatDate(this.order.st,0,true) }}</p></v-col>
                           
                          </v-row>

                        </v-card-text>

                      </v-card>

                      <!-- Formulario -->
                      <v-card outlined tile class="mb-6">

                        <v-card-title class="px-3 py-2" style="background-color:#F5F5F5; color:#686D70; border-bottom: 1px solid #E0E0E0;" >
                          <v-icon medium>mdi-format-list-bulleted-square</v-icon>
                          <span class="body-1 text-center font-weight-bold ml-2">Formulario</span>
                        </v-card-title>

                        <v-card-text class="px-6 py-6">

                          <v-row v-if="this.order.ej">
                            <v-col lg="1" md="1" sm="1" class="d-none d-sm-flex"></v-col>
                            <v-col lg="4" md="4" sm="4" cols="6"><p class="text-left mb-0">COMENTARIO</p></v-col>
                            <v-col lg="7" md="7" sm="7" cols="6"><p class="text-left mb-0" >{{this.order.ej.cm ? this.order.ej.cm : 'No identificado'  }}</p></v-col> 
                          </v-row>
                         
                          <template v-if="this.order.images && this.order.images.length > 0">
                            
                            <v-row>
                              <v-col lg="1" md="1" sm="1" class="d-none d-sm-flex"></v-col>
                              <v-col lg="5" md="6" sm="6" cols="8"><p class="text-left mb-0 text-uppercase">Fotos del pedido</p></v-col>
                            </v-row>
                              
                            <v-row>                        
                              <v-col lg="10" offset-lg="1" md="10" offset-md="1" sm="10" offset-sm="1" cols="12">
                                <v-row>
                                  <v-col lg="6" md="6" sm="6" cols="12" v-for="(imagen,index) in this.order.images"  :key="index"  @click="() => showImg($hostImages + imagen)">
  
                                      <pedido-imagen
                                        :image64="$hostImages + imagen"
                                      ></pedido-imagen> 

                                  </v-col>

                                  <vue-easy-lightbox
                                    scrollDisabled 
                                    moveDisabled
                                    :visible="visible"
                                    :imgs="imgs"
                                    @hide="handleHide"
                                  ></vue-easy-lightbox>

                                </v-row>
                              </v-col>
                            </v-row>
                            
                          </template>


                          <template v-else>
                            <v-row>
                              <v-col lg="1" md="1" class="mdAndUp"></v-col>
                              <v-col lg="4" md="4" sm="4" cols="12"><p class="text-left mb-0 text-uppercase">Fotos del pedido</p></v-col>
                              <v-col lg="7" md="7" sm="7" cols="12">Sin imágenes para mostrar</v-col>
                            </v-row>
                          </template>

                        </v-card-text>

                      </v-card>



                  </v-col>
                  
                </v-row>
            </v-col>
            
        </template>
       
    </div>

    
    <pedido-loader
      :loaded="loaded"
      :overlay="overlay"
    ></pedido-loader>
     

  </div>
</template>

<script>

  import VueEasyLightbox from 'vue-easy-lightbox'

  //COMPONENTS
  import PedidoNotFound    from '../components/NotFound.vue'
  import PedidoMap         from '../components/Map.vue'
  import PedidoSeguimiento from '../components/Seguimiento.vue'
  import PedidoImage       from '../components/Image'
  import PedidoLoader      from '../components/Loader'

  //API CALLS
  import ubicServices from '../services/ubicServices'

  import Utils  from '../utils/utils'  

export default {
    name: 'pedido',
    components: {
      VueEasyLightbox
    },
    components: {
      'pedido-not-found':   PedidoNotFound,
      'pedido-map':         PedidoMap,
      'pedido-seguimiento': PedidoSeguimiento,
      'pedido-imagen':      PedidoImage,
      'pedido-loader':      PedidoLoader
    },
    created() {
       this.loginApiUbic() 
    },
    data() {
      return {
        loaded: false,
        overlay: true,
        visible: false,
        httpstatus: '',
        order: [],
        imgs: '',
      }
    },
    methods: {
      loginApiUbic: async function () {
        try {

            //REAL INFORMATION
            let response = await ubicServices.callGetOrdes(this.$route.params.pedido)
            this.order = response.data.datos

            //MOCKED
            // let response = await ubicServices.getMocked(this.$route.params.pedido)
            // this.order = response[0].datos
          
        } catch (error) {
            //console.log(error)
            if(error.response){
                if(error.response.data.code == 401) {
                  this.httpstatus = error.response.data.code
                } else if (error.response.data.code == 400) {
                  this.httpstatus = error.response.data.code
                }
            }else if(error) {
                this.httpstatus = 401
            }else{
               
            }
        } finally {
          this.overlay = false
          this.loaded = true
        }
      },
      formatDate (date,way,time) {
        let fecha = new Date( date * 1000) 
        let tiempo = fecha.toTimeString().substr(0,5)
        let newfecha = Utils.formatDate(fecha.toDateString(),way)
       
        if(time) {
          return newfecha +" a las "+ tiempo
        } else {
          return newfecha
        }
        
      },
      formatPhone(phoneNumber) {
        return Utils.formatPhoneNumber(phoneNumber)
      },
      showImg(imagen) {
        //this.imgs = 'data:image/jpeg;base64,'+imagen
        this.imgs = imagen
        this.visible = true
      },
      handleHide() {
        this.visible = false
      }

    }
}
</script>


<style>

</style>
